import {Component, HostListener, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';
import {MainMenuStructureService} from '../../../../../services/main-menu-structure.service';

@Component({
  selector: 'app-university-info-edit',
  templateUrl: './university-info-edit.component.html',
  styleUrls: ['./university-info-edit.component.scss']
})
export class UniversityInfoEditComponent implements OnInit {

  settings: Map<String, boolean> = new Map();

  constructor(private _dialogRef: MatDialogRef<UniversityInfoEditComponent>,
              private _mainMenuStructureService: MainMenuStructureService,
              @Inject(MAT_DIALOG_DATA) private data: any) {
  }

  ngOnInit() {
    this.loadSettings();
  }

  loadSettings(): void {
    this._mainMenuStructureService.getUniversityInfoSettings().subscribe(
      response => {
        this.settings = response;
      },
      err => {
        console.log(err);
      },
      () => {
      });
  }

  getKeys(map) {
    return Object.keys(map);
  }

  close(): void {
    this._dialogRef.close();
  }

  save(): void {
    this._dialogRef.close(this.settings);
  }

  @HostListener("keydown.esc")
  public onEsc() {
    this._dialogRef.close();
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/admin/components/public-page/main-menu/university-info-dialog/edit/university-info-edit.component.ts